import React from 'react'
import { Flex, Spacer } from '@chakra-ui/react'

import MessageMethods from './methods'
import { useMessageProperties } from '../message-provider'
import WrittenBackIndicator from './written-back-indicator'
import SharedStack from '~components/shared/wrappers/shared-stack'
import MessagePatient from './message-patient'
import MessageTimestamp from './message-timestamp'

export default function MessageDetailsInfo() {
    const { message } = useMessageProperties()

    return (
        <Flex
            flexDir="row"
            mt={3}
            gap={2}
            justify="space-between"
            align="center"
        >
            <MessagePatient />
            <Spacer />
            <SharedStack
                row
                fit
                gap={2}
                color="blackAlpha.400"
                divider={
                    <span
                        style={{
                            fontSize: '10px',
                        }}
                    >
                        •
                    </span>
                }
            >
                {message.written_back_at && <WrittenBackIndicator />}
                <MessageMethods />
            </SharedStack>
            <MessageTimestamp />
        </Flex>
    )
}
